/* global React, ReactDOM, BentoViewV2, MenuModal, KaraokeModal, OffersModal,
   MasterclassModal, TerraceModal, GenericModal, TosyMap, SiteLink, Splash */

// ─────────────────────────────────────────────
// TOSY mobile app — standalone shell.
// Splash shows once per session, skippable by tapping through.
// Was inline in index.html; lifted out so it can be precompiled with
// the rest of the JSX instead of needing Babel in the browser.
// ─────────────────────────────────────────────
function App() {
  const [entered, setEntered] = React.useState(() => {
    try { return sessionStorage.getItem('tosy-entered') === '1'; } catch (e) { return false; }
  });
  const enter = () => {
    try { sessionStorage.setItem('tosy-entered', '1'); } catch (e) {}
    setEntered(true);
  };

  const [booking, setBooking] = React.useState(false);
  const [menu, setMenu] = React.useState(false);
  const [karaoke, setKaraoke] = React.useState(false);
  const [offers, setOffers] = React.useState(false);
  const [cls, setCls] = React.useState(false);
  const [terrace, setTerrace] = React.useState(false);
  const [find, setFind] = React.useState(false);
  const [faq, setFaq] = React.useState(false);
  const [evt, setEvt] = React.useState(false);
  const E = window.TOSY_EVENT || {};
  const accent = '#ff2e88';

  // Back button: with a sheet open, back closes the sheet instead of
  // leaving the site. Opening any sheet pushes one history entry;
  // closing it (by any means) consumes that entry again.
  const anyOpen = menu || karaoke || offers || cls || terrace || find || faq || evt;
  const closeAll = () => { setMenu(false); setKaraoke(false); setOffers(false); setCls(false); setTerrace(false); setFind(false); setFaq(false); setEvt(false); };
  React.useEffect(() => {
    if (anyOpen && !window.__sheetPushed) {
      window.__sheetPushed = true;
      history.pushState({ tosySheet: true }, '');
    } else if (!anyOpen && window.__sheetPushed) {
      window.__sheetPushed = false;
      if (history.state && history.state.tosySheet) history.back();
    }
  }, [anyOpen]);
  React.useEffect(() => {
    const onPop = () => { window.__sheetPushed = false; closeAll(); };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--ink)', display: 'flex', justifyContent: 'center' }}>
      <div style={{ position: 'relative', width: '100%', maxWidth: 470, height: '100%', overflow: 'hidden', background: 'var(--ink)' }}>
        <div className="no-scrollbar" style={{ height: '100%', overflow: 'auto' }}>
          <BentoViewV2
            onOpenBooking={() => window.open('https://bookings.theoldschoolyard.com/book/tosy', '_blank', 'noopener')}
            onOpenMenu={() => setMenu(true)}
            onOpenKaraoke={() => setKaraoke(true)}
            onOpenOffers={() => setOffers(true)}
            onOpenClass={() => setCls(true)}
            onOpenTerrace={() => setTerrace(true)}
            onOpenFind={() => setFind(true)}
            onOpenFAQ={() => setFaq(true)}
            onOpenEvent={() => setEvt(true)}
          />
        </div>
        {!entered && <div style={{ position: 'absolute', inset: 0, zIndex: 200 }}><Splash onEnter={enter} /></div>}
        <MenuModal open={menu} onClose={() => setMenu(false)} accent={accent} />
        <KaraokeModal open={karaoke} onClose={() => setKaraoke(false)} accent={accent} />
        <OffersModal open={offers} onClose={() => setOffers(false)} onViewMenu={() => { setOffers(false); setMenu(true); }} accent={accent} />
        <MasterclassModal open={cls} onClose={() => setCls(false)} accent={accent} />
        <TerraceModal open={terrace} onClose={() => setTerrace(false)} accent={accent} />
        <GenericModal open={find} onClose={() => setFind(false)} accent={accent} title="FIND US" subtitle="111 Long Lane, SE1 4PH." body={<>
          <TosyMap />
          <p><strong>From London Bridge:</strong> take the Guy's Hospital exit, walk through the hospital grounds and down Crosby Row, then turn left onto Long Lane.</p>
          <p><strong>From Borough:</strong> cross to the opposite corner of the crossroads from the station exit, then walk down Long Lane.</p>
          <p>Google: 4.2★  ·  DesignMyNight: 5.0★</p>
          <p style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 14 }}>
            <a href="tel:02073576281" style={{ flex: '1 1 30%', textAlign: 'center', padding: '11px 8px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.22)', color: 'var(--bone)', textDecoration: 'none', fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: '0.18em' }}>CALL US</a>
            <a href="https://wa.me/447405289375" target="_blank" rel="noreferrer" style={{ flex: '1 1 30%', textAlign: 'center', padding: '11px 8px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.22)', color: 'var(--bone)', textDecoration: 'none', fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: '0.18em' }}>WHATSAPP</a>
            <a href="https://maps.google.com/?q=The+Old+School+Yard,+111+Long+Lane,+London+SE1+4PH" target="_blank" rel="noreferrer" style={{ flex: '1 1 30%', textAlign: 'center', padding: '11px 8px', borderRadius: 8, background: '#ff2e88', color: '#fff', textDecoration: 'none', fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: '0.18em', fontWeight: 700 }}>OPEN MAPS</a>
          </p>
          <p style={{ fontSize: 12, opacity: 0.6 }}>what3words: ///doors.enjoy.hang</p>
          <SiteLink slug="best-bars-london-bridge/"
            title="Best bars near London Bridge"
            note="Our guide to the area — and where we fit in it" />
        </>} />
        <GenericModal open={faq} onClose={() => setFaq(false)} accent={accent} title="FAQs" subtitle="Quick answers." body={<>
          <p><strong style={{ color: '#fff' }}>Do I need to book?</strong> Not for drinks at the bar — walk in any time we're open. Karaoke rooms should be booked ahead.</p>
          <p><strong style={{ color: '#fff' }}>How much is a room?</strong> From £7.50 per person (Tue &amp; Wed, 1 hour) — or choose a minimum spend behind the bar instead, where your card is only held, not charged, and the money goes on drinks. Exact prices show live as you book.</p>
          <p><strong style={{ color: '#fff' }}>Last-minute?</strong> Per-person spots in the shared Karaoke Studio from £5/hour — book online any time, even when we can't answer the phone.</p>
          <p><strong style={{ color: '#fff' }}>Food?</strong> Crisps and bar snacks at the bar. For a proper meal, food is by SMOK'D — a separate kitchen, ordered direct from them. Have a look under Menus. Wait times are down to their kitchen, so allow a bit longer when we're busy.</p>
          <p><strong style={{ color: '#fff' }}>Hen parties?</strong> Yes — we do them every week.</p>
          <SiteLink slug="private-hire-london-bridge/"
            title="Private hire & big group bookings"
            note="Hen dos, birthdays, work parties — capacities and packages" />
          <p><strong style={{ color: '#fff' }}>How do I book a room?</strong> Online at bookings.theoldschoolyard.com, or call us.</p>
        </>} />
        {evt && (
          <div onClick={() => setEvt(false)} style={{ position: 'absolute', inset: 0, zIndex: 300, background: 'rgba(7,13,28,0.8)', backdropFilter: 'blur(8px)' }}>
            <div onClick={e => e.stopPropagation()} style={{
              position: 'absolute', bottom: 0, left: 0, right: 0, background: '#f2e8d0',
              borderRadius: '24px 24px 0 0', maxHeight: '90%', overflow: 'auto', color: '#3a3128',
              animation: 'fade-up 0.35s cubic-bezier(0.2,0.9,0.3,1)',
            }}>
              <img src={E.poster} alt={E.name} style={{ width: '100%', display: 'block' }} />
              <div style={{ padding: 22, paddingBottom: 36 }}>
                <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, letterSpacing: '0.25em', color: '#1f6b52', marginBottom: 10 }}>{E.dateLabel.toUpperCase()} · {E.doors.toUpperCase()}</div>
                <p style={{ fontFamily: "'Inter Tight', sans-serif", fontSize: 14, lineHeight: 1.6, margin: '0 0 16px' }}>{E.blurb}</p>
                <div style={{ display: 'grid', gap: 8, marginBottom: 16 }}>
                  {[['Music', E.genres], ['On the night', E.extras], ['Early bird', E.price], ['Anytime', E.priceLate]].map(([k, v]) => (
                    <div key={k} style={{ display: 'flex', gap: 12, fontSize: 13, borderTop: '1px solid rgba(58,49,40,0.15)', paddingTop: 8 }}>
                      <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, letterSpacing: '0.14em', color: '#1f6b52', width: 84, flexShrink: 0, paddingTop: 2 }}>{k.toUpperCase()}</span>
                      <span style={{ fontFamily: "'Inter Tight', sans-serif" }}>{v}</span>
                    </div>
                  ))}
                </div>
                <a href={E.url} target="_blank" rel="noopener" style={{
                  display: 'block', textAlign: 'center', padding: '16px 0', borderRadius: 8,
                  background: '#b4232a', color: '#fff', textDecoration: 'none',
                  fontFamily: "'JetBrains Mono', monospace", fontSize: 11, letterSpacing: '0.3em', fontWeight: 700,
                }}>GET TICKETS</a>
                <div style={{ marginTop: 12, textAlign: 'center', fontFamily: "'JetBrains Mono', monospace", fontSize: 8, letterSpacing: '0.14em', opacity: 0.55 }}>{E.note.toUpperCase()}</div>
              </div>
            </div>
          </div>
        )}
        <div className="grain" />
      </div>
    </div>
  );
}

// Exposed so prerender.mjs can render this exact tree to static HTML at build
// time, rather than keeping a second copy of the shell in the build script.
window.App = App;

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
